// store/modules/fisimed.js
import Patient from '@/script/Patient.js';

export default {
    namespaced: true,
    state: () => ({
        count: 0,
        patientCourant: {},
        lesPatients: {},
        test: { nom: 'Alias', prenom: 'ALI' }
    }),
    getters: {
        getLesPatients: state => state.lesPatients,
        getPatientCourant: state => {
            const pc = { ...state.patientCourant };
            if (pc.DateNaissance) pc.DateNaissance = new Date(pc.DateNaissance).toLocaleDateString('fr');
            if (pc.DateCreation) pc.DateCreation = new Date(pc.DateCreation).toLocaleDateString('fr');
            return pc;
        },
        getTest: state => state.test
    },
    mutations: {
        increment(state) {
            state.count++;
        },
        setParientCourant(state, patient) {
            state.patientCourant = patient;
        },
        setLesPatientsBySearh(state, patients) {
            state.lesPatients = patients;
        }
    },
    actions: {
        async setPatientCourant({ commit }, id) {
            if (id) {
                const response = await Patient.getPatientById(id);
                commit('setParientCourant', response);
            }
        },
        async setLesPatientsBySearh({ commit }, critere) {
            if (!critere) critere = "a";
            const response = await Patient.getPatientBySearch(critere);
            commit("setLesPatientsBySearh", response);
        }
    }
};
